import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import {NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';

const OrganismePiedPage = (props) =>
{
    const [piedPage, setPiedPage] = useState('');

    const green = '#59B44A';
    const purple = '#6571FE';

    async function mount()
    {
        if (props.user && props.user.id_organisme)
        {
            await axios.post('/api/organismes.php', qs.stringify({
                'getOrganismes': true,
                'id': props.user.id_organisme
            }))
            .then((res) => {
                if (res && res.data && res.data[0]) {
                    setPiedPage(res.data[0].pied_page || '');
                }
            })
            .catch((err) => {
                console.warn(err);
            });
        }
    }

    useEffect(() => {
        mount();
    }, [props.user]);

    const updatePiedPage = async () => {
        try {
            const params = {
                'updateOrganisme': true,
                'id': props.user.id_organisme,
                'pied_page': piedPage
            };
            const res = await axios.post('/api/organismes.php', qs.stringify(params));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success('Pied de page mis à jour avec succès.', '', 2000);
            } else {
                const msg = res && res.data && res.data.status_message ? res.data.status_message : 'Erreur mise à jour pied de page';
                NotificationManager.error(msg, '', 4000);
            }
        } catch (e) {
            NotificationManager.error('Erreur lors de la requête de mise à jour.', '', 4000);
            console.error(e);
        }
    };

    return (
        <div className='shadow-md' style={{textAlign: 'left', borderRadius: 3, padding: 20, margin: 1, backgroundColor: 'white'}}>
            <div style={{textAlign: 'center'}}>
                <p style={{fontWeight: 'bold', fontSize: 16, marginBottom: 20, color: purple}}>Pied de page</p>
            </div>

            <div>
                <label style={{display: 'block', marginBottom: 6, fontWeight: 600}}>Texte affiché en bas des documents PDF</label>
                <input
                    type='text'
                    value={piedPage}
                    onChange={(e) => setPiedPage(e.target.value)}
                    style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}}
                    placeholder='Ex : Établissement public foncier local – SIRET 000 000 000 00000'
                />
            </div>

            <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: 20}}>
                <button
                    onClick={updatePiedPage}
                    style={{padding: '8px 12px', borderRadius: 4, backgroundColor: green, color: 'white', border: 'none', cursor: 'pointer'}}
                >
                    Mettre à jour
                </button>
            </div>
        </div>
    );
}

export default OrganismePiedPage;
